export default "__VITE_ASSET__8TR5z6Ve__"